import { defineComponent, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { usePermissionsStore } from '@/store/permissions.store';
import { usePresetSettingsStore } from '@/store/preset-settings/preset-settings.store';
import { Plus, Refresh } from '@element-plus/icons-vue';
import { PresetSettingsButtonName } from '@/models/preset-settings/preset-settings.model';
import { PRESET_SETTINGS_PERMISSIONS } from '@/models/app-internal/permissions.model';

const icons = {
  Plus,
  Refresh,
};

export default defineComponent({
  name: 'ConfigListHeader',
  emits: ['show-add-country-dialog'],
  setup() {
    const { presetSettingsPermissions } = usePermissionsStore();
    const presetSettingsStore = usePresetSettingsStore();
    const { getCashierConfigList } = presetSettingsStore;
    const { isCashierConfigListLoading } = storeToRefs(presetSettingsStore);

    const isChangeCountrySettingsAvailable = computed<boolean>(() =>
      presetSettingsPermissions[PRESET_SETTINGS_PERMISSIONS.CREATE_CASHIER_CONFIG] &&
      presetSettingsPermissions[PRESET_SETTINGS_PERMISSIONS.UPDATE_CASHIER_CONFIG]);

    return {
      icons,
      PresetSettingsButtonName,
      isChangeCountrySettingsAvailable,
      getCashierConfigList,
      isCashierConfigListLoading,
    };
  },
});
